import { BoxPlusIcon, BoxMinusIcon } from "@/base/static/index";
import { tablePrefixCls } from "@/base/components/table/Table.component";

export const ExpandIcon = ({ expanded, onExpand, record }: any) => {
  if (!record.children) {
    return null;
  }

  return expanded ? (
    <BoxPlusIcon
      className={`${tablePrefixCls}-expand-icon`}
      onClick={(e) => onExpand(record, e)}
    />
  ) : (
    <BoxMinusIcon
      className={`${tablePrefixCls}-expand-icon`}
      onClick={(e) => onExpand(record, e)}
    />
  );
};
